import {
  SET_NORMAL_CHECKOUT_CURRENT_STEP,
  SET_POST_CHECKOUT_CURRENT_STEP,
  SET_CREDIT_CHECK_PERSONAL_DATA,
  SET_CREDIT_CHECK_EMPLOYMENT_DATA,
  SET_CREDIT_CHECK_HOME_DATA,
  SET_CREDIT_CHECK_DEBIT_DATA,
  SET_CREDIT_CHECK_DELIVERY_DATA,
  SET_CREDIT_CHECK_CONTACT_DATA,
  SET_CREDIT_CHECK_AFFORD_DEAL,
  SET_CREDIT_SELECTED_AFFORD_DEAL,
  SET_NUMBER_TO_TRANSFER,
  SET_NUMBER_TRANSFER_TYPE,
  SET_NUMBER_TRANSFER_DETAILS,
  SET_CREDIT_VETTING_OUTCOME,
  SET_PAYMENT_METHOD,
  SET_PAYMENT_METHOD_URL,
  SET_POST_ORDER_RESPONSE,
} from "../actionTypes/index";

export const setNormalCheckoutCurrentStep = (result) => async (dispatch) => {
  if (typeof result != "undefined" && result !== "") {
    dispatch({ type: SET_NORMAL_CHECKOUT_CURRENT_STEP, payload: result });
  }
};

export const setPostCheckoutCurrentStep = (result) => async (dispatch) => {
  if (typeof result != "undefined" && result !== "") {
    dispatch({ type: SET_POST_CHECKOUT_CURRENT_STEP, payload: result });
  }
};

export const setNumberTranferType = (type) => ({
  type: SET_NUMBER_TRANSFER_TYPE,
  payload: type,
});

export const setNumberToTranfer = (number) => ({
  type: SET_NUMBER_TO_TRANSFER,
  payload: number,
});

export const setNumberTransferDetails = (payload) => ({
  type: SET_NUMBER_TRANSFER_DETAILS,
  payload,
});

export const removeCreditCheckStates = (result) => async (dispatch) => {
  if (typeof result != "undefined" && result !== "") {
    dispatch({ type: SET_CREDIT_CHECK_PERSONAL_DATA, payload: result });
    dispatch({ type: SET_CREDIT_CHECK_EMPLOYMENT_DATA, payload: result });
    dispatch({ type: SET_CREDIT_CHECK_HOME_DATA, payload: result });
    dispatch({ type: SET_CREDIT_CHECK_DEBIT_DATA, payload: result });
    dispatch({ type: SET_CREDIT_CHECK_DELIVERY_DATA, payload: result });
    dispatch({ type: SET_CREDIT_CHECK_CONTACT_DATA, payload: result });
    dispatch({ type: SET_CREDIT_CHECK_AFFORD_DEAL, payload: false });
    dispatch({ type: SET_CREDIT_SELECTED_AFFORD_DEAL, payload: true });
    dispatch({ type: SET_CREDIT_VETTING_OUTCOME, payload: result });
  }
};

export const setPaymentMethodCode = (result) => async (dispatch) => {
  if (typeof result != undefined && result != "") {
    dispatch({ type: SET_PAYMENT_METHOD, payload: result });
  }
};

export const setPaymentMethodUrl = (result) => async (dispatch) => {
  if (typeof result != undefined && result != "") {
    dispatch({ type: SET_PAYMENT_METHOD_URL, payload: result });
  }
};

export const setPostOrderResponse = (result) => async (dispatch) => {
  if (typeof result != undefined && result != "") {
    dispatch({ type: SET_POST_ORDER_RESPONSE, payload: result });
  }
};
